import { render } from "./MscEditModal.vue?vue&type=template&id=5f83a719&scoped=true&ts=true"
import script from "./MscEditModal.vue?vue&type=script&lang=ts"
export * from "./MscEditModal.vue?vue&type=script&lang=ts"

import "./MscEditModal.vue?vue&type=style&index=0&id=5f83a719&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f83a719"]])

export default __exports__